import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ConsultaPaginadaViewModel } from '../../model/model.api';
import { ConsultarGradeDeTamanhoViewModel, GradeDeTamanhoViewModel } from 'models/confeccoes/GradesDeTamanhosViewModel';

@Injectable()
export class GradesDeTamanhosServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('GradesTamanhos', http);
  }

  consultarGradesDeTamanhos(payload: ConsultarGradeDeTamanhoViewModel) {
    return this.postPaginatedAsPromise<ConsultarGradeDeTamanhoViewModel, ConsultaPaginadaViewModel<GradeDeTamanhoViewModel>>(payload, 'consultarGradesDeTamanhos');
  }

}